import { Box, Container, Grid, Tooltip } from '@mui/material';
// import React, { ChangeEvent, useEffect, useRef, useState } from 'react';
import Headings from './../../common/headings/headings';
import "./skills.scss";

export default function Skills() {

    const _mSkills = [
        {
            type: "Technologies I Work With", l: 9, list: ["javascript.svg", "typescript.svg", "angular.svg", "react.svg",
                "nodejs.svg", "firebase.svg", "google-cloud-functions.svg", "material-ui.svg", "reactivejs.svg", "python.svg", "shadcn-ui.svg", "tailwind.svg"]
        }, 
        {
            type: "", l: 6, list: ["redux.svg", "nextjs.svg", "zod.svg", "chartjs.svg", "gsap.svg", "opensearch.svg",
              "ngrx.svg" , "angular-pwa.svg"]},
        {
            type: "", l: 9, list: ["django.svg", 
                "ionic.svg", "mongodb.svg", "graphql.svg", "flutter.svg", "pixijs.svg", "docker.svg", "aws.svg", "zustand.svg" ]
        },
        { type: "Tools", l: 6, list: ["postman.svg", "git.svg", "gitlab.svg", "figma.svg", "netlify.svg", "bitbucket.svg"] }
    ]

    // const [value, setValue] = useState(1);

    // // The counter
    // const [count, setCount] = useState<number>(0)
    // // Dynamic delay
    // const [delay, setDelay] = useState<number>(100)
    // ON/OFF
    // const [isPlaying, setPlaying] = useState<boolean>(true)

    // useInterval(() => {
    //     // Your custom logic here
    //     if (count === 12) {
    //         setCount(0);
    //     } else {
    //         setCount(count + 1);
    //     }
    // }, isPlaying ? delay : null);


    // function useInterval(callback: () => void, delay: number | null) {
    //     const savedCallback = useRef(callback)

    //     // Remember the latest callback if it changes.
    //     useEffect(() => {
    //         savedCallback.current = callback
    //     }, [callback])

    //     // Set up the interval.
    //     useEffect(() => {
    //         // Don't schedule if no delay is specified.
    //         if (delay === null) {
    //             return
    //         }
    //         const id = setInterval(() => savedCallback.current(), delay)
    //         return () => clearInterval(id)
    //     }, [(delay)])
    // }

    // const handleChange = (event: any, newValue: number | number[]) => {
    //     setValue(Number(newValue));
    //     console.log(Math.round(delay * value));

    //     setDelay(Number(Math.round(value)));
    // };

    // const handleChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
    //     setDelay(Number(event.target.value))
    // }

    return (
        <div className="">
            <Container maxWidth="lg">
                <Headings heading="skills"></Headings>

                {/* <div className="ui-width--156">
                    <Slider
                        value={value} onChange={handleChange}
                        defaultValue={100}
                        step={100}
                        min={100}
                        max={1000}
                    />
                </div> */}
                <div className="ui-padding--8"></div>


                {/* {_mSkills.map((value, key) => (
                    <Box display="flex" flexDirection="column" key={key}>
                        <div className="ui-padding--8"></div>

                        <h4 className="ui-typo--h4 ui-text--capitalize ui-theme--primary ui-font-weight--normal">
                            <i>{value.type}</i>
                        </h4>
                        <div className="ui-padding--16"></div>
                        <Grid container spacing={2}>
                            {value.list.map((icon, key) => (
                                <Grid item xs={3} sm={2} md={1} lg={1} key={key}>
                                    <Tooltip title={icon.split(".")[0].toUpperCase()}>
                                        <div className={"ui-padding--8 " + (key === count ? "colored" : "greyscale")}>
                                            <div className="ui-border--r14 ui-padding--8 ui-rect--64 ui-glassmoprhic-bg skill-card">
                                                <img src={"assets/logo/" + icon} className="ui-image" alt={icon.split(".")[0]} />
                                            </div>
                                        </div>
                                    </Tooltip>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                ))} */}



                {_mSkills.map((value, key) => (
                    <Box display="flex" flexDirection="column" key={key}>
                        <div className="ui-padding--8"></div>

                        <h4 className="ui-typo--h4 ui-text--capitalize ui-theme--primary ui-font-weight--normal">
                            <i>{value.type}</i>
                        </h4>
                        {/* <p className="ui-typo--body2 ui-padding--left-12">{value.quote}</p> */}
                        <div className="ui-padding--16"></div>
                        <Grid container spacing={2} className="lightrope">
                            {value.list.map((icon, key) => (
                                <Grid item xs={3} sm={2} md={1} lg={1} key={key}>
                                    <Tooltip title={icon.split(".")[0]} className='ui-text--capitalize'>
                                        <div className={"ui-padding--8 light-" + (key+1)}>
                                            <div className="ui-border--r14 ui-padding--8 ui-rect--64 ui-glassmoprhic-bg skill-card">
                                                <img src={"assets/logo/" + icon} className="ui-image" alt={icon.split(".")[0]} />
                                            </div>
                                        </div>
                                    </Tooltip>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                ))}
            </Container>

        </div>
    )
}




// {/* <canvas
//                 id="canvas"
//                 ref={canvasRef}
//                 width={500}
//                 height={500}
//                 style={{
//                     border: '2px solid #000',
//                     marginTop: 10,
//                 }}
//             ></canvas> */}


             // const canvasRef = React.useRef<HTMLCanvasElement>(null);
    // const [context, setContext] = React.useState<CanvasRenderingContext2D | null>(null);

    // React.useEffect(() => {
    //     if (canvasRef.current) {
    //         const renderCtx = canvasRef.current.getContext('2d');

    //         if (renderCtx) {
    //             setContext(renderCtx);
    //         }

    //         if (context) {
    //             context.beginPath();
    //             context.arc(10, 100, 10, 0, Math.PI * 2);
    //             context.fillStyle = "#0095DD";
    //             context.fill();
    //             context.closePath();
    //             context.fillRect(5, 5, 100, 100);
    //         }
    //     }
    // }, [context]);